import {
  Button,
  ButtonVariant,
  IconIdentifier,
} from '@aus-platform/design-system';
import classNames from 'classnames';
import React from 'react';

type SectionHeaderProps = {
  backLabel: string;
  description: string;
  onBack: VoidFunction;
  className?: string;
};

export const SectionHeader: React.FC<SectionHeaderProps> = ({
  backLabel,
  description,
  onBack,
  className,
}) => {
  // Variables.
  const customClassname = classNames('section-header', className);

  return (
    <div className={customClassname}>
      <Button
        className="section-header__back-btn"
        variant={ButtonVariant.Link}
        leftIconIdentifier={IconIdentifier.ChevronBigLeft}
        iconSize={14}
        onClick={onBack}
      >
        {backLabel}
      </Button>

      <p className="section-header__description">{description}</p>
    </div>
  );
};
